(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brand-home-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    function start(el) {
      var B = window.BRAND;
      if (!el || el.getAttribute('data-brand-ready') === '1') return;
      if (!B || !B.flags || B.flags.countdown !== true || !B.facts || !B.facts.cutoff) return;
      var c = B.facts.cutoff;
      var hWeek = parseInt(c.hour, 10);
      var hSat = c.hourSat === null || c.hourSat === undefined || c.hourSat === '' ? NaN : parseInt(c.hourSat, 10);
      if (!c.tz || isNaN(hWeek)) return;
      var fmt;
      try {
        fmt = new Intl.DateTimeFormat('en-US', { timeZone: c.tz, hourCycle: 'h23', weekday: 'short', hour: '2-digit', minute: '2-digit', second: '2-digit' });
      } catch (e) { return; }
      var days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
      var label = el.querySelector('[data-brand-bind="countdown.label"]');
      var timer = el.querySelector('[data-brand-bind="countdown.timer"]');
      function hourFor(wd) {
        if (wd >= 1 && wd <= 5) return hWeek;
        if (wd === 6 && !isNaN(hSat)) return hSat;
        return null;
      }
      function tick() {
        var o = {};
        fmt.formatToParts(new Date()).forEach(function (p) { o[p.type] = p.value; });
        var wd = days.indexOf(o.weekday);
        var now = (parseInt(o.hour, 10) % 24) * 3600 + parseInt(o.minute, 10) * 60 + parseInt(o.second, 10);
        var h = hourFor(wd), diff = null, today = false;
        if (h !== null && now < h * 3600) { diff = h * 3600 - now; today = true; }
        else {
          for (var d = 1; d <= 7; d++) {
            var hn = hourFor((wd + d) % 7);
            if (hn !== null) { diff = d * 86400 + hn * 3600 - now; break; }
          }
        }
        if (diff === null || diff < 0) { el.hidden = true; return; }
        var hh = Math.floor(diff / 3600), mm = Math.floor((diff % 3600) / 60), ss = diff % 60;
        label.textContent = today ? el.getAttribute('data-today') : el.getAttribute('data-next');
        timer.textContent = pad(hh) + ':' + pad(mm) + ':' + pad(ss);
        el.hidden = false;
      }
      el.setAttribute('data-brand-ready', '1');
      tick();
      setInterval(tick, 1000);
    }
    function scan(root) {
      (root || document).querySelectorAll('[data-brand-component="home-countdown"]').forEach(start);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { scan(); });
    else scan();
    document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
